import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentsService } from "services";
import { uiActions } from "store";
import { ErrorResponse, usePaymentsListProps } from "types";

const useDeleteWithholdMutation = ({
	paidMonth,
	paidYear,
	refetchWithholdList,
}: usePaymentsListProps) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			id,
		}: {
			id: string;
			changeResidualsStatus?: Function;
			changeAgentResidualsStatus?: Function;
		}) => {
			dispatch(uiActions.showSpinnerOverlay());
			return paymentsService.deleteWithholdPayment(
				paidMonth,
				paidYear,
				id,
			);
		},
		{
			onSuccess: () => {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Withhold data successfully deleted",
					}),
				);
				refetchWithholdList();
			},
			onError(error: ErrorResponse, data) {
				if (error.title === "agent_payout_details_missed") {
					dispatch(
						uiActions.showModal("CONFIRMATION", {
							title: [
								"Payout details are still not populated.",
								"Please add payout details.",
							],
							isButtonOkHidden: true,
						}),
					);
				} else if (error.title === "agent_residuals_status_withhold") {
					dispatch(
						uiActions.showModal("CONFIRMATION", {
							title: [
								"Agent residuals status - Withhold.",
								"Do you want to delete the withhold and update agent residuals status to pay residuals?",
							],
							onConfirm: data?.changeResidualsStatus,
						}),
					);
				} else if (
					error.title === "merchant_residuals_status_withhold"
				) {
					dispatch(
						uiActions.showModal("CONFIRMATION", {
							title: [
								"Merchant residuals status - Withhold.",
								"Do you want to delete the withhold and update merchant residuals status to pay residuals?",
								"All agents will be affected.",
							],
							onConfirm: data?.changeResidualsStatus,
						}),
					);
				} else {
					dispatch(
						uiActions.showErrorNotification({
							title: getErrorMessage(error),
						}),
					);
				}
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useDeleteWithholdMutation;
